import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import "../../Home.css";
import { useLocation } from "react-router-dom";

const CookiePolicy = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Cookie Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-content pt-50 pb-50">
        <div className="site-width">
          <div className="about-card">
            <div className="titleSection text-center wow animate__fadeInDown">
              <h3>HOURLEE - COOKIE POLICY</h3>
            </div>

            <p>
              <strong>Effective Date: </strong>&nbsp;07 January 2026
              <strong>
                <br /> Last Updated:{" "}
              </strong>
              &nbsp;07 January 2026
            </p>
            <p>
              This Cookie Policy explains how{" "}
              <strong>RightO Services Private Ltd.</strong>, operating its
              platform under the brand name <strong>Hourlee</strong>{" "}
              (&ldquo;Hourlee&rdquo;, &ldquo;we&rdquo;, &ldquo;our&rdquo;,
              &ldquo;us&rdquo;), uses cookies and similar tracking technologies
              when you visit or interact with our website, mobile application,
              or services (&ldquo;Platform&rdquo;).
            </p>
            <p>
              This Policy should be read alongside our{" "}
              <strong>Privacy Notice</strong>, which explains how we process
              your personal data in compliance with applicable data protection
              laws, including the{" "}
              <strong>
                Digital Personal Data Protection Act, 2023 (DPDP Act)
              </strong>
              , and <strong>GDPR</strong>, and other relevant privacy laws.
            </p>
            <h3>
              <strong>1. What Are Cookies?</strong>
            </h3>
            <p>
              Cookies are small text files placed on your device (computer,
              tablet, or mobile) by a website you visit. These files store small
              amounts of information to help the website remember your actions,
              preferences, or session details.
            </p>
            <ul>
              <li>
                <strong>First-party cookies</strong> are placed by Hourlee (the
                domain you are visiting).
                <br />{" "}
              </li>
              <li>
                <strong>Third-party cookies</strong> are placed by other domains
                or services integrated into our Platform, such as analytics,
                social media integrations, advertising partners, or embedded
                service providers.
                <br />{" "}
              </li>
            </ul>
            <p>
              Cookies enable efficient navigation, enhance user experience,
              support security functions, and help us understand usage patterns.
            </p>
            <h3>
              <strong>2. Data Collected Through Cookies </strong>
            </h3>
            <p>Cookies may collect information, including:</p>
            <ul>
              <li>IP Address</li>
              <li>Device Information</li>
              <li>Browser type and version</li>
              <li>Pages visit</li>
              <li>Links clicked</li>
              <li>Session duration</li>
              <li>Navigation Paths</li>
              <li>Login and authentication status</li>
            </ul>
            <h3>
              <strong>3. Why We Use Cookies</strong>
            </h3>
            <p>
              Hourlee uses cookies and similar tracking technologies for the
              following purposes:
            </p>
            <h3>
              <strong>3.1 Essential Platform Functionality</strong>
            </h3>
            <ul>
              <li>
                To enable login functionality.
                <br />{" "}
              </li>
              <li>
                To operate secure sections of the platform, including job
                posting, application submissions, and wallet/escrow
                functionality.
                <br />{" "}
              </li>
              <li>
                To maintain session integrity and prevent fraudulent activities.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>3.2 Website &amp; App Navigation</strong>
            </h3>
            <ul>
              <li>
                Assisting you in navigating the Platform and using key features.
                <br />{" "}
              </li>
              <li>
                Remembering items such as your selected region, device type, and
                session progress.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>3.3 Analytics &amp; Performance</strong>
            </h3>
            <ul>
              <li>
                Understanding how users interact with the Platform.
                <br />{" "}
              </li>
              <li>
                Measuring traffic, engagement, and performance trends.
                <br />{" "}
              </li>
              <li>
                Improving content, features, UI/UX, and overall platform
                functionality.
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>3.4 Personalisation &amp; Preference Management</strong>
            </h3>
            <ul>
              <li>
                Remembering your preferred language, display settings, and other
                interface choices.
                <br />{" "}
              </li>
              <li>
                Saving your cookie preferences and consent selections (required
                by law).
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>
                3.5 Advertising &amp; Marketing (including Behavioural
                Advertising)
              </strong>
            </h3>
            <ul>
              <li>
                Delivering relevant ads and promotional offers based on your
                interests and interactions.
                <br />{" "}
              </li>
              <li>
                Integrating with marketing tools (e.g., Google Ads, social media
                pixels) where legally permitted.
                <br />{" "}
              </li>
              <li>
                Measuring ad performance and reach.
                <br />{" "}
              </li>
            </ul>
            <p>
              We obtain your consent before deploying any{" "}
              <strong>non-essential cookies</strong> (Analytics, Marketing,
              Advertising, or Personalisation cookies). Only{" "}
              <strong>strictly necessary cookies</strong> operate without
              consent.
            </p>
            <h3>
              <strong>4. Types of Cookies Used by Hourlee</strong>
            </h3>
            <h3>
              <strong>4.1 Strictly Necessary Cookies</strong>
            </h3>
            <p>
              These cookies are essential for the operation of the Hourlee
              Platform. These cookies are necessary for the functioning of our
              Platform, including secure logins, account management, job
              applications, and site navigation.
            </p>
            <p>
              They enable security, user authentication, payment flows, job
              application processes, and access to core features. Without these
              cookies, we cannot provide the services you request.
              <br /> <strong>These cookies do not require user consent.</strong>
            </p>
            <h3>
              <strong>4.2 Analytics Cookies</strong>
            </h3>
            <p>
              Analytics cookies help us understand how visitors use our
              Platform, including:
            </p>
            <ul>
              <li>
                Page visit counts
                <br />{" "}
              </li>
              <li>
                Time spent on pages
                <br />{" "}
              </li>
              <li>
                Device/browser types
                <br />{" "}
              </li>
              <li>
                User interaction flows
                <br />{" "}
              </li>
            </ul>
            <p>
              These cookies help us analyze user behavior, website performance,
              and traffic sources so we can improve the user experience.
            </p>
            <h3>
              <strong>4.3 Functional Cookies</strong>
            </h3>
            <p>
              Functional cookies enable enhanced functionality and
              personalization.
              <br /> &nbsp;They remember user preferences such as:
            </p>
            <ul>
              <li>
                Language settings
                <br />{" "}
              </li>
              <li>
                Saved user settings
                <br />{" "}
              </li>
              <li>
                UI preferences
                <br />{" "}
              </li>
              <li>
                Displayed content layouts
                <br />{" "}
              </li>
            </ul>
            <p>
              These cookies remember your preferences, such as language, saved
              searches, and recently viewed job postings. These cookies improve
              usability but are not strictly necessary.
            </p>
            <h3>
              <strong>4.4 Advertising &amp; Marketing Cookies</strong>
            </h3>
            <p>These cookies help us:</p>
            <ul>
              <li>
                Deliver targeted ads tailored to your interests
                <br />{" "}
              </li>
              <li>
                Measure ad campaign performance
                <br />{" "}
              </li>
              <li>
                Limit the frequency of ad display
                <br />{" "}
              </li>
              <li>
                Understand user behaviour for marketing optimisation
                <br />{" "}
              </li>
            </ul>
            <p>
              We may use third‑party cookies to show relevant job
              recommendations and advertisements based on your browsing history.
            </p>
            <h3>
              <strong>5. First-Party Cookies vs. Third-Party Cookies</strong>
            </h3>
            <h3>
              <strong>5.1 First-Party Cookies </strong>
            </h3>
            <p>
              Placed directly by Hourlee to ensure Platform functionality,
              preference management, and analytics.
            </p>
            <h3>
              <strong>5.2 Third-Party Cookies</strong>
            </h3>
            <p>
              Placed by external service providers integrated into Hourlee, such
              as:
            </p>
            <ul>
              <li>
                Analytics providers (e.g., Google Analytics)
                <br />{" "}
              </li>
              <li>
                Advertising partners (e.g., Meta, Google Ads)
                <br />{" "}
              </li>
              <li>
                Social media platforms (e.g., LinkedIn, Instagram)
                <br />{" "}
              </li>
              <li>
                Payment/technical infrastructure providers
                <br />{" "}
              </li>
            </ul>
            <p>
              Third-party cookies may track your interactions across different
              websites, depending on their own privacy practices. We may allow
              trusted partners such as analytics providers (e.g., Google
              Analytics) and advertising networks to place cookies on your
              device. These partners may collect information about your online
              activities across different websites.
            </p>
            <p>
              We do not control third‑party cookies. Please review their
              respective policies for more information.
            </p>
            <h3>
              <strong>6. Consent for Non-Essential Cookies</strong>
            </h3>
            <p>
              Where required by law (GDPR, DPDP Act), we obtain your consent
              before placing non-essential cookies on your device.
            </p>
            <p>
              You will see a <strong>cookie banner</strong> when you first visit
              Hourlee, offering the following choices:
            </p>
            <ul>
              <li>
                <strong>Accept</strong> - allow all non-essential cookies
                <br />{" "}
              </li>
              <li>
                <strong>Decline</strong> - only essential cookies will be used
                <br />{" "}
              </li>
              <li>
                <strong>Manage Settings</strong> - customise cookie preferences
                <br />{" "}
              </li>
            </ul>
            <p>
              If you decline, we will not load analytics or marketing cookies,
              and we will only store a single cookie to remember your
              preference.
            </p>
            <h3>
              <strong>7. Managing &amp; Disabling Cookies</strong>
            </h3>
            <p>You have complete control over your cookie preferences.</p>
            <h3>
              <strong>7.1 Through the Hourlee Cookie Banner</strong>
            </h3>
            <p>
              Upon first visit, select your preference. You may revisit your
              cookie settings at any time through your browser or account.
            </p>
            <h3>
              <strong>7.2 Through Browser Settings</strong>
            </h3>
            <p>
              Most web browsers allow you to disable or delete cookies in their
              settings.
              <br /> &nbsp;Below are common links:
            </p>
            <ul>
              <li>
                <strong>Chrome</strong> - chrome://settings/cookies
                <br />{" "}
              </li>
              <li>
                <strong>Firefox</strong> - about: preferences#privacy
                <br />{" "}
              </li>
              <li>
                <strong>Safari</strong> -Preferences &rarr; Privacy
                <br />{" "}
              </li>
              <li>
                <strong>Edge</strong> - edge://settings/content
                <br />{" "}
              </li>
            </ul>
            <h3>
              <strong>7.3 Opt-Out of Analytics</strong>
            </h3>
            <p>
              For Google Analytics:
              <br />{" "}
              <a href="https://tools.google.com/dlpage/gaoptout">&nbsp;</a>
              <a href="https://tools.google.com/dlpage/gaoptout">
                https://tools.google.com/dlpage/gaoptout
              </a>
            </p>
            <p>
              Please note:
              <br /> Disabling cookies may affect the availability or
              functionality of some platform features, including personalised
              recommendations, login persistence, and payment workflows
            </p>
            <h3>
              <strong>8. Retention of Cookies </strong>
            </h3>
            <p>
              We retain cookies for different periods depending on their
              purpose. Session cookies expire when you close your browser, while
              persistent cookies may remain stored until manually deleted or
              automatically removed after expiry.
            </p>
            <h3>
              <strong>9. Updates &amp; Review</strong>
            </h3>
            <p>We may update this Cookie Policy periodically to reflect:</p>
            <ul>
              <li>
                changes in technology,
                <br />{" "}
              </li>
              <li>
                legal and regulatory requirements,
                <br />{" "}
              </li>
              <li>
                operational or business practices.
                <br />{" "}
              </li>
            </ul>
            <p>
              We recommend reviewing this page regularly.
              <br /> The &ldquo;Last Updated&rdquo; date at the top of this page
              indicates when the Policy was most recently revised.
            </p>
            <h3>
              <strong>10. Contact Us</strong>
            </h3>
            <p>
              If you have questions or concerns about this Cookie Policy or our
              use of cookies, please contact:
            </p>
            <p>
              <strong>
                RightO Services Private Ltd. (Hourlee)
                <br />{" "}
              </strong>
              &nbsp;Email:{" "}
              <strong>
                Privacy@hourlee.in
                <br />{" "}
              </strong>
              &nbsp;Address: 52/1 Park Road, Dehradun -248001, India
              <br /> &nbsp;Phone: +91-9811999641
            </p>
            <p>&nbsp;</p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default CookiePolicy;
